<template>
  <div>
    <Navbar />

    <!-- Sección historia -->
    <section class="container historia-section">
      <div class="row align-items-center historia-row">
        <!-- Texto -->
        <div class="col-md-6 text-start historia-texto">
          <h1 class="fw-bold mb-4 display-6 lh-sm historia-titulo">
            ¿Cuál es la historia<br />
            de GM Risk?
          </h1>

          <p class="mb-3 historia-parrafo">
            GM Risk nace en la ciudad de Puebla en 2001 con la visión de ayudar
            a nuestros clientes y acompañarlos en el proceso de elegir el mejor
            seguro acorde a sus necesidades, siempre buscando su beneficio.
            Desde nuestros inicios, entendimos que cada persona y cada negocio
            tiene necesidades únicas. Por eso, decidimos no limitar al
            asegurado a una sola opción.
          </p>

          <h2 class="fw-bold historia-subtitulo">
            Objetivo
          </h2>

          <p class="mb-3 historia-parrafo">
            Nuestro objetivo es ofrecer alternativas reales, equilibrando
            costo, cobertura y servicio, para que cada cliente tome una
            decisión informada y acorde a su etapa de vida. Buscamos asesorar
            con honestidad, cuidando que cada póliza represente valor y
            protección real.
          </p>

          <p class="historia-parrafo">
            Hoy, con más de dos décadas de experiencia, mantenemos firme
            nuestro compromiso: ser una guía cercana, profesional y humana en
            el camino de proteger lo que más importa.
          </p>
        </div>

        <!-- Imagen -->
        <div class="col-md-6 text-center historia-imagen-col">
          <img
            src="/image/nosotros.jpg"
            alt="Equipo de GM Risk"
            class="img-fluid rounded shadow-sm historia-imagen"
          />
        </div>
      </div>
    </section>

    <!-- Sección trayectoria -->
    <section class="trayectoria-section">
      <div class="container trayectoria-container">
        <!-- Texto sobre el carrusel -->
        <div class="trayectoria-texto">
          <h3 class="fw-bold mb-3 trayectoria-titulo">
            Trayectoria del equipo
          </h3>

          <p class="trayectoria-descripcion">
            Con más de 25 años en el ramo asegurador, hemos trabajado de manera
            constante, llegando a asegurar a miles de personas, trabajando con
            empresas, escuelas y personas de manera independiente.
          </p>
        </div>

        <!-- Carrusel -->
        <div
          id="teamCarousel"
          class="carousel slide rounded overflow-hidden trayectoria-carousel"
          data-bs-ride="carousel"
        >
          <div class="carousel-inner trayectoria-inner">
            <div class="carousel-item active">
              <div class="position-relative trayectoria-slide">
                <img
                  src="/image/tramites2.JPG"
                  class="d-block w-100 trayectoria-imagen"
                  alt="Trayectoria del equipo GM Risk"
                />

                <div class="trayectoria-overlay"></div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="position-relative trayectoria-slide">
                <img
                  src="/image/tramites.jpg"
                  class="d-block w-100 trayectoria-imagen"
                  alt="Experiencia del equipo GM Risk"
                />

                <div class="trayectoria-overlay"></div>
              </div>
            </div>
          </div>

          <!-- Controles -->
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#teamCarousel"
            data-bs-slide="prev"
          >
            <span
              class="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>

            <span class="visually-hidden">
              Anterior
            </span>
          </button>

          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#teamCarousel"
            data-bs-slide="next"
          >
            <span
              class="carousel-control-next-icon"
              aria-hidden="true"
            ></span>

            <span class="visually-hidden">
              Siguiente
            </span>
          </button>
        </div>
      </div>
    </section>

    <!-- Sección equipo -->
    <section class="container equipo-section">
      <h2 class="text-center fw-bold equipo-titulo">
        Conoce nuestro equipo
      </h2>

      <div class="row g-4">
        <!-- Primeros dos integrantes -->
        <div
          v-for="(miembro, index) in equipo.slice(0, 2)"
          :key="index"
          class="col-md-6"
        >
          <article class="miembro-equipo">
            <img
              :src="miembro.imagen"
              :alt="`Foto de ${miembro.nombre}`"
              class="miembro-imagen"
            />

            <div class="miembro-contenido">
              <h4 class="fw-bold mb-3">
                {{ miembro.nombre }}
              </h4>

              <p
                :class="{
                  'text-truncate-multiline': !miembro.expandido
                }"
                :style="
                  miembro.expandido
                    ? {
                        maxHeight: 'none',
                        overflow: 'visible'
                      }
                    : {}
                "
                class="miembro-descripcion"
              >
                {{
                  miembro.expandido
                    ? miembro.descripcion
                    : miembro.descripcionCorta
                }}
              </p>

              <button
                type="button"
                class="btn btn-outline-primary btn-sm mt-2"
                @click="toggleExpand(index)"
              >
                {{ miembro.expandido ? "Ver menos" : "Ver más" }}
              </button>
            </div>
          </article>
        </div>

        <!-- Tercer integrante -->
        <div class="col-md-6">
          <article class="miembro-equipo miembro-equipo-tercero">
            <img
              :src="equipo[2].imagen"
              :alt="`Foto de ${equipo[2].nombre}`"
              class="miembro-imagen"
            />

            <div class="miembro-contenido">
              <h4 class="fw-bold mb-3">
                {{ equipo[2].nombre }}
              </h4>

              <p
                :class="{
                  'text-truncate-multiline': !equipo[2].expandido
                }"
                :style="
                  equipo[2].expandido
                    ? {
                        maxHeight: 'none',
                        overflow: 'visible'
                      }
                    : {}
                "
                class="miembro-descripcion"
              >
                {{
                  equipo[2].expandido
                    ? equipo[2].descripcion
                    : equipo[2].descripcionCorta
                }}
              </p>

              <button
                type="button"
                class="btn btn-outline-primary btn-sm mt-2"
                @click="toggleExpand(2)"
              >
                {{ equipo[2].expandido ? "Ver menos" : "Ver más" }}
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

export default {
  name: "SobreNosotros",

  components: {
    Navbar
  },

  data() {
    return {
      equipo: [
        {
          nombre: "Paul Garcia",
          imagen: "/image/paul.jpg",
          descripcion:
            "Director y socio fundador de GM Risk, especializado en el área de daños. Como parte del equipo se encarga de dar atención a nuestros clientes empresariales, ya que cuenta con amplia experiencia en brindar el mejor servicio para colectivos, pues su trayectoria e inmersión directa en este medio le han permitido especializarse en temas como gastos médicos, transporte, seguros educativos, etc.",
          descripcionCorta:
            "Director y socio fundador de GM Risk, especializado en el área de daños. Como parte del equipo se encarga de dar atención a nuestros clientes empresariales...",
          expandido: false
        },
        {
          nombre: "Julieta Mendoza",
          imagen: "/image/julieta.jpg",
          descripcion:
            "Desde muy joven inicié trabajando dentro de una de las aseguradoras más importantes del país, para posteriormente emprender como agente independiente y finalmente, junto con mi socio, fundar GM Risk. Se encarga de brindar atención personalizada a nuestros clientes en seguros de personas, pues su trayectoria y experiencia le han brindado las herramientas para ser intermediaria y apoyo entre las compañías aseguradoras, el cliente y los terceros involucrados en una póliza.",
          descripcionCorta:
            "Desde muy joven inició trabajando dentro de una de las aseguradoras más importantes del país, para posteriormente emprender como agente independiente y finalmente...",
          expandido: false
        },
        {
          nombre: "Jafet García",
          imagen: "/image/abraham.jpg",
          descripcion:
            "Licenciado en Mercadotecnia y Dirección de Negocios, su visión, innovación y preparación en el medio empresarial lo hacen pieza clave para GM Risk. Está encargado de crear alianzas estratégicas para el broker y los asegurados, buscando mejorar la experiencia de cada uno de nuestros clientes.",
          descripcionCorta:
            "Licenciado en Mercadotecnia y Dirección de Negocios, su visión e innovación lo hacen pieza clave para GM Risk...",
          expandido: false
        }
      ]
    };
  },

  methods: {
    toggleExpand(index) {
      this.equipo[index].expandido =
        !this.equipo[index].expandido;
    }
  }
};
</script>

<style scoped>
/* =========================================
   ESTILOS GENERALES
========================================= */

.historia-section,
.trayectoria-section,
.equipo-section {
  width: 100%;
}

.historia-section {
  padding-top: 5rem;
  padding-bottom: 3rem;
}

.historia-row {
  row-gap: 2rem;
}

.historia-titulo,
.historia-subtitulo {
  color: #0e4460;
  font-family: "Open Sans", sans-serif;
  word-break: normal;
  overflow-wrap: normal;
}

.historia-titulo {
  font-size: 2.5rem;
  line-height: 1.2;
}

.historia-subtitulo {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.historia-parrafo {
  margin-bottom: 1rem;
  font-size: 1.2rem;
  line-height: 1.8;
  text-align: justify;
  word-break: normal;
  overflow-wrap: normal;
}

.historia-imagen {
  display: block;
  width: 90%;
  height: auto;
  margin: 20px auto 0;
}

/* =========================================
   TRAYECTORIA
========================================= */

.trayectoria-section {
  margin: 3rem 0;
  overflow: hidden;
}

.trayectoria-container {
  position: relative;
  width: 100%;
  max-width: 1320px;
  height: 500px;
  padding: 0;
}

.trayectoria-carousel {
  width: 100%;
  height: 500px;
  margin-top: 3rem;
}

.trayectoria-inner,
.trayectoria-inner .carousel-item,
.trayectoria-slide {
  width: 100%;
  height: 500px;
}

.trayectoria-imagen {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.trayectoria-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
}

.trayectoria-texto {
  position: absolute;
  top: 25%;
  left: 50%;
  z-index: 10;
  width: calc(100% - 32px);
  max-width: 700px;
  padding: 0 1rem;
  color: #ffffff;
  text-align: center;
  transform: translateX(-50%);
}

.trayectoria-titulo,
.trayectoria-descripcion {
  word-break: normal;
  overflow-wrap: normal;
}

.trayectoria-titulo {
  font-size: 2rem;
}

.trayectoria-descripcion {
  margin-bottom: 0;
  font-size: 1.25rem;
  line-height: 1.6;
}

/* =========================================
   EQUIPO
========================================= */

.equipo-section {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.equipo-titulo {
  margin-bottom: 3rem;
  color: #0e4460;
}

.miembro-equipo {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  width: 100%;
  min-width: 0;
  padding: 0 1rem;
}

.miembro-equipo-tercero {
  max-width: 600px;
}

.miembro-imagen {
  display: block;
  width: 280px;
  max-width: 100%;
  height: auto;
  flex-shrink: 0;
  object-fit: contain;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.miembro-contenido {
  flex: 1;
  min-width: 0;
}

.miembro-contenido h4,
.miembro-contenido p {
  word-break: normal;
  overflow-wrap: normal;
}

.miembro-descripcion {
  max-height: 5.4em;
  margin-bottom: 0;
  overflow: hidden;
  line-height: 1.6;
  transition: max-height 0.3s ease;
}

.text-truncate-multiline {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* =========================================
   LAPTOPS PEQUEÑAS
========================================= */

@media (max-width: 1199.98px) {
  .historia-titulo {
    font-size: 2.2rem;
  }

  .historia-parrafo {
    font-size: 1.05rem;
    line-height: 1.7;
  }

  .miembro-equipo {
    gap: 1rem;
  }

  .miembro-imagen {
    width: 210px;
  }

  .miembro-contenido h4 {
    font-size: 1.15rem;
  }

  .miembro-contenido p {
    font-size: 0.92rem;
  }
}

/* =========================================
   TABLETS
========================================= */

@media (max-width: 991.98px) {
  .historia-section {
    padding-top: 3.5rem;
    padding-bottom: 2.5rem;
  }

  .historia-titulo {
    font-size: 2rem;
  }

  .historia-parrafo {
    font-size: 1rem;
    line-height: 1.65;
    text-align: left;
  }

  .historia-imagen {
    width: 100%;
  }

  .trayectoria-container,
  .trayectoria-carousel,
  .trayectoria-inner,
  .trayectoria-inner .carousel-item,
  .trayectoria-slide {
    height: 430px;
  }

  .trayectoria-texto {
    top: 50%;
    width: 82%;
    transform: translate(-50%, -50%);
  }

  .trayectoria-titulo {
    font-size: 1.8rem;
  }

  .trayectoria-descripcion {
    font-size: 1.05rem;
    line-height: 1.55;
  }

  .miembro-equipo {
    flex-direction: column;
    align-items: stretch;
  }

  .miembro-imagen {
    width: 100%;
  }

  .miembro-equipo-tercero {
    max-width: none;
  }
}

/* =========================================
   CELULARES
========================================= */

@media (max-width: 767.98px) {
  .historia-section {
    padding-top: 2.5rem;
    padding-bottom: 2.25rem;
  }

  .historia-titulo {
    margin-bottom: 1.25rem !important;
    font-size: 1.85rem;
  }

  .historia-titulo br {
    display: none;
  }

  .historia-subtitulo {
    font-size: 1.45rem;
  }

  .historia-parrafo {
    font-size: 0.96rem;
    line-height: 1.65;
  }

  .historia-imagen {
    margin-top: 10px;
  }

  .trayectoria-section {
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 0 12px;
  }

  .trayectoria-container,
  .trayectoria-carousel,
  .trayectoria-inner,
  .trayectoria-inner .carousel-item,
  .trayectoria-slide {
    height: 390px;
  }

  .trayectoria-carousel {
    margin-top: 0;
  }

  .trayectoria-texto {
    width: 84%;
  }

  .trayectoria-titulo {
    margin-bottom: 0.75rem !important;
    font-size: 1.55rem;
    line-height: 1.25;
  }

  .trayectoria-descripcion {
    font-size: 0.93rem;
    line-height: 1.5;
  }

  .trayectoria-carousel .carousel-control-prev,
  .trayectoria-carousel .carousel-control-next {
    width: 12%;
  }

  .trayectoria-carousel .carousel-control-prev-icon,
  .trayectoria-carousel .carousel-control-next-icon {
    width: 22px;
    height: 22px;
  }

  .equipo-section {
    margin-top: 3rem;
    margin-bottom: 3rem;
    padding-left: 16px;
    padding-right: 16px;
  }

  .equipo-titulo {
    margin-bottom: 2rem;
    font-size: 1.8rem;
  }

  .miembro-equipo {
    padding: 0;
  }

  .miembro-imagen {
    width: 100%;
    max-height: 430px;
  }

  .miembro-contenido h4 {
    margin-bottom: 0.75rem !important;
    font-size: 1.2rem;
  }

  .miembro-contenido p {
    font-size: 0.94rem;
    line-height: 1.55;
  }

  .miembro-contenido .btn {
    min-width: 100px;
    min-height: 38px;
  }
}

/* =========================================
   CELULARES PEQUEÑOS
========================================= */

@media (max-width: 575.98px) {
  .historia-section {
    padding-left: 16px;
    padding-right: 16px;
  }

  .historia-titulo {
    font-size: 1.65rem;
  }

  .historia-subtitulo {
    font-size: 1.35rem;
  }

  .historia-parrafo {
    font-size: 0.92rem;
    line-height: 1.6;
  }

  .trayectoria-container,
  .trayectoria-carousel,
  .trayectoria-inner,
  .trayectoria-inner .carousel-item,
  .trayectoria-slide {
    height: 350px;
  }

  .trayectoria-texto {
    width: 88%;
  }

  .trayectoria-titulo {
    font-size: 1.35rem;
  }

  .trayectoria-descripcion {
    font-size: 0.85rem;
    line-height: 1.45;
  }

  .equipo-titulo {
    font-size: 1.6rem;
  }

  .miembro-imagen {
    max-height: 380px;
  }

  .miembro-contenido h4 {
    font-size: 1.1rem;
  }

  .miembro-contenido p {
    font-size: 0.9rem;
  }
}

/* =========================================
   CELULARES MUY PEQUEÑOS
========================================= */

@media (max-width: 380px) {
  .historia-section {
    padding-left: 12px;
    padding-right: 12px;
  }

  .historia-titulo {
    font-size: 1.5rem;
  }

  .trayectoria-section {
    padding-left: 8px;
    padding-right: 8px;
  }

  .trayectoria-container,
  .trayectoria-carousel,
  .trayectoria-inner,
  .trayectoria-inner .carousel-item,
  .trayectoria-slide {
    height: 330px;
  }

  .trayectoria-titulo {
    font-size: 1.22rem;
  }

  .trayectoria-descripcion {
    font-size: 0.78rem;
  }

  .equipo-section {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>